import { EntityCategory } from '../../../entities/EventLog/EventLog'
import { DetailLog } from '../../PacoLogsModal/helpers'

export const isRedundantShiftPlanningLog = (
    isShiftLog: boolean,
    key: string,
    field: string,
    value: string,
    shiftStartValue: string|undefined,
    shiftEndValue: string|undefined,
): boolean => (
    isShiftLog
        && key === EntityCategory.ShiftPlanning
        && (
            (field === 'startTime' && shiftStartValue !== undefined && value === shiftStartValue)
            || (field === 'endTime' && shiftEndValue !== undefined && value === shiftEndValue)
        )
)

export const findShiftStartAndEndValues = (detailRows: DetailLog<string>[]): { shiftStartValue: string|undefined, shiftEndValue: string|undefined } => {
    const shiftStartValue = detailRows.find(
        ({ key, field }) => key === EntityCategory.Shift && field === 'startTime',
    )?.value
    const shiftEndValue = detailRows.find(
        ({ key, field }) => key === EntityCategory.Shift && field === 'endTime',
    )?.value

    return {
        shiftStartValue,
        shiftEndValue,
    }
}
